export default __webpack_public_path__ + "media/components/Pages/Abitur/Images/How/4-30917231d07a8823568950221c9f20fe.svg";